import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Checkbox } from "semantic-ui-react";
import Selector from "./selector";
import "./size-selector.css";
import { setDivClass, sizeToFit } from "../../actions";

const SizeSelector = ({ children, selectors, includeSizeToFit }) => {
  const dispatch = useDispatch();
  const divClass = useSelector((state) => state.divClass || "desktop");
  const [divSize, setDivSize] = useState();

  const onSelect = useCallback(
    (value, size, title) => {
      dispatch(setDivClass(`${value} ${title}`));
      setDivSize(size);
    },
    [dispatch]
  );

  useEffect(() => {
    if (selectors && selectors.length) {
      setDivSize(selectors[0].width);
      dispatch(setDivClass(`${selectors[0].icon} ${selectors[0].title}`));
      selectors.forEach((selector) => {
        if (selector.icon === "desktop") {
          setDivSize(selector.width);
          dispatch(setDivClass(`${selector.icon} ${selector.title}`));
        }
      });
    } else {
      dispatch(setDivClass("desktop"));
    }
    return () => {
      dispatch(sizeToFit(false));
    };
  }, [selectors, dispatch]);

  const handleCheckboxChange = (event, { checked }) =>
    dispatch(sizeToFit(checked));

  return (
    <Grid centered>
      <Grid.Row>
        <Grid.Column className="stage">
          <div id="stage" className={divClass} style={{ width: divSize }}>
            {children}
            {selectors && selectors.length > 0 && (
              <div id="size-selector">
                {selectors.map((selector, index) => (
                  <Selector key={index} onSelect={onSelect} {...selector} />
                ))}
              </div>
            )}
            {includeSizeToFit && (
              <Checkbox
                label="Size to fit"
                onChange={handleCheckboxChange}
                className="size-to-fit"
              />
            )}
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default SizeSelector;
